import {styled, css, keyframes} from '@innowise-group/ui-kit';

interface FloorAttendanceContainerProps {
  isSecondPlan?: boolean;
  isShowSecondPlan?: boolean;
}

const shimmer = keyframes`
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
`;

const boneBase = css`
  display: block;
  flex-shrink: 0;
  background: linear-gradient(
    90deg,
    ${({theme}) => theme.palette.general.lightGrey[40]} 0%,
    ${({theme}) => theme.palette.general.lightGrey[20]} 45%,
    ${({theme}) => theme.palette.general.lightGrey[40]} 90%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.35s ease-in-out infinite;
`;

export const SkeletonBone = styled.span<{
  $width?: number | string;
  $height?: number;
  $radius?: number;
}>`
  ${boneBase};
  width: ${({$width = 64}) => (typeof $width === 'number' ? `${$width}px` : $width)};
  height: ${({$height = 10}) => $height}px;
  border-radius: ${({$radius = 4}) => $radius}px;
`;

export const FloorAttendanceContainer = styled.div<FloorAttendanceContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background-color: white;
  overflow: hidden;
  padding: 12px 20px;
  position: absolute;
  top: 20px;
  z-index: 5;
  box-shadow: 0px 0px 7px 1px #00000024;
  transform: translateX(-50%);

  ${({isShowSecondPlan, isSecondPlan}) =>
    isShowSecondPlan
      ? `width: 500px;
        ${
          isSecondPlan
            ? `
              right: 23%;
              transform: translateX(50%);
              `
            : `left: 23%;`
        }`
      : `
        width: 750px;
        left: 50%;
      `}
`;

export const StatsBlock = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 8px 12px;
  font-weight: 500;
`;

interface AttendanceFloorBadgeProps {
  backgroundColor: string;
  color: string;
}

export const AttendanceFloorPercentage = styled.div<AttendanceFloorBadgeProps>`
  font-size: 16px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 7px;
  background-color: ${({backgroundColor}) => backgroundColor};
  color: ${({color}) => color};
`;
